/**
 * How do I get a z-index for my new item?
 *
 * Decide a meaningful name for your item and then insert it
 * in the indices array below. The higher up your item visually,
 * then the higher it will be in the z-index stack,
 * 'higher' means _earlier_ in the array.
 *
 * Eg. stickyAdWrapper will be given a higher z-index than bodyArea
 *
 * Once inserted in the array, use getZIndex() to return the css
 *
 * Eg.
 *
 * import { getZIndex } from './getZIndex';
 *
 * const myCss = css`
 *    color: blue;
 *    ${getZIndex('TheGuardian')}
 * `;
 *
 * As new items are added, all z-indexes are adjusted
 */
const indices = [
    // Modals will go here at the top
    // Sticky video and button need to be above everything
    'sticky-video-button',
    'sticky-video',
    'banner',
    'dropdown',
    'burger',
    'expanded-veggie-menu-wrapper',
    'expanded-veggie-menu',
    // Headers with sticky ads
    'stickyAdWrapperLabsHeader',
    'stickyAdWrapper',
    'stickyAdWrapperNav',
    // Edition selector in nav - needs to be below stickyAdWrapper
    'editionDropdown',
    // Liveblog toast
    'toast',
    // Onwards Carousel (Related content etc)
    'onwardsCarousel',
    // Search link should be above The Guardian svg
    'searchHeaderLink',
    'TheGuardian',
    // Wrapper after nav stuff
    'headerWrapper',
    // Article headline (should be above main media)
    'articleHeadline',
    'immersiveBlackBox',
    // Body
    'bodyArea',
    'rightColumnArea',
    // Main media
    'mainMedia',
];
const decideIndex = (name) => {
    const index = indices.indexOf(name);
    if (index === -1)
        return null; // indexOf returns -1 if there is no match
    return indices.length - index; // reverse the indices: last item gets 1
};
export const getZIndex = (zIndex) => `z-index: ${decideIndex(zIndex)};`;
export const getZIndexImportant = (zIndex) => `z-index: ${decideIndex(zIndex)} !important;`;
